import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  shareByThemes: {
    key: 'niche-chart-selector-shareByThemes',
    defaultValue: 'Share por Temas',
  },
})
